import React from "react";

const MapIconDark = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6.66602 2.88735L2.0371 5.97329C1.80527 6.12785 1.66602 6.38804 1.66602 6.66667V16.6667C1.66602 16.974 1.83517 17.2564 2.10613 17.4014C2.3771 17.5464 2.70589 17.5305 2.9616 17.36L6.66602 14.8904V2.88735Z"
        fill="#000000b3"
      />
      <path
        d="M8.33268 14.8904L11.666 17.1127V5.10957L8.33268 2.88735V14.8904Z"
        fill="#000000b3"
      />
      <path
        d="M13.3327 5.10957V17.1127L17.9616 14.0267C18.1934 13.8722 18.3327 13.612 18.3327 13.3333V3.33333C18.3327 3.02601 18.1635 2.74362 17.8926 2.59861C17.6216 2.45359 17.2928 2.46948 17.0371 2.63996L13.3327 5.10957Z"
        fill="#000000b3"
      />
    </svg>
  );
};

export default MapIconDark;
